import cmsSharedConstantsEn from '../views/cms/i18n/cmsForm.i18n.en';
import cmsSharedConstantsAr from '../views/cms/i18n/cmsForm.i18n.ar';
import cmsEditPrivacyPolicyConstantsEn from '../views/cms/i18n/editPrivacyPolicy/editPrivacyPolicy.i18n.en';
import cmsEditPrivacyPolicyConstantsAr from '../views/cms/i18n/editPrivacyPolicy/editPrivacyPolicy.i18n.ar';
import editTermsConditionsConstantsAr from '../views/cms/i18n/editTermsConditions/editTermsConditions.i18n.ar';
import editTermsConditionsConstantsEn from '../views/cms/i18n/editTermsConditions/editTermsConditions.i18n.en';
import editCookiesPoliciesConstantsAr from '../views/cms/i18n/editCookiesPolicy/editCookiesPolicy.i18n.ar';
import editCookiesPoliciesConstantsEn from '../views/cms/i18n/editCookiesPolicy/editCookiesPolicy.i18n.en';
import editFAQsConstantsAr from '../views/cms/i18n/editFAQs/editFAQs.i18n.ar';
import editFAQsConstantsEn from '../views/cms/i18n/editFAQs/editFAQs.i18n.en';
import editAboutUsEn from '../views/cms/i18n/editAboutUs/editAboutUs.i18n.en';
import editAboutUsAr from '../views/cms/i18n/editAboutUs/editAboutUs.i18n.ar';
import blogConstantsAr from '../views/cms/i18n/blog/blog.i18n.ar';
import blogConstantsEn from '../views/cms/i18n/blog/blog.i18n.en';
import blogListConstantsAr from '../views/cms/i18n/blogsList/blogList.i18n.ar';
import blogListConstantsEn from '../views/cms/i18n/blogsList/blogsList.i18n.en';
import copyRightsConstantEN from '../i18n/CopyRights.i18n.en';
import copyRightsConstantAR from '../i18n/CopyRights.i18n.ar';
import topBarConstantsAR from '../i18n/Header.i18n.ar';
import topBarConstantsEN from '../i18n/Header.i18n.en';
import sideBarConstantsAR from '../i18n/SideBar.i18n.ar';
import sideBarConstantsEN from '../i18n/SideBar.i18n.en';
import validationsAR from '../i18n/Validation.i18n.ar';
import validationsEN from '../i18n/Validation.i18n.en';
import successStoriesConstantsAr from '../views/cms/i18n/successStories/successStories.i18n.ar';
import successStoriesConstantsEn from '../views/cms/i18n/successStories/successStories.i18n.en';
import twoFactorFormConstantsAR from '../views/auth/i18n/TwoFactorAuth.i18n.ar';
import twoFactorFormConstantsEN from '../views/auth/i18n/TwoFactorAuth.i18n.en';
import approvedDomainsConstantsAr from '../views/ApprovedDomains/i18n/approvedDomains.i18n.ar';
import approvedDomainsConstantsEn from '../views/ApprovedDomains/i18n/approvedDomains.i18n.en';
import adminUserConstantsAr from '../views/userManagement/i18n/adminUser/adminUser.i18n.ar';
import adminUserConstantsEn from '../views/userManagement/i18n/adminUser/adminUser.i18n.en';
import adminUserSharedConstantsAr from '../views/userManagement/i18n/adminUserShared.i18n.ar';
import adminUserSharedConstantsEn from '../views/userManagement/i18n/adminUserShared.i18n.en';
import adminUsersListConstantsAr from '../views/userManagement/i18n/adminUsersList/adminUsersList.i18n.ar';
import adminUsersListConstantsEn from '../views/userManagement/i18n/adminUsersList/adminUsersList.i18n.en';
import searchPlaceHolderConstantsAr from '../i18n/searchPlaceHolder.i18n.ar';
import searchPlaceHolderConstantsEn from '../i18n/searchPlaceHolder.i18n.en';
import tableConstantsAr from '../i18n/table.i18n.ar';
import tableConstantsEn from '../i18n/table.i18n.en';
import cmsPagesConstantsEn from '../views/cms/i18n/cmsPages/cmsPages.i18n.en';
import cmsPagesConstantsAr from '../views/cms/i18n/cmsPages/cmsPages.i18n.ar';
import userManagementConstantsAr from '../views/userManagement/i18n/userManagement.i18n.ar';
import userManagementConstantsEn from '../views/userManagement/i18n/userManagement.i18n.en';
import forgotPasswordFormConstantsEN from '../views/auth/i18n/ForgotPassword.i18n.en';
import forgotPasswordFormConstantsAR from '../views/auth/i18n/ForgotPassword.i18n.ar';
import resetPasswordFormConstantsEN from '../views/auth/i18n/ResetPassword.i18n.en';
import resetPasswordFormConstantsAR from '../views/auth/i18n/ResetPassword.i18n.ar';
import signInFormConstantsEN from '../views/auth/i18n/SigninForm.i18n.en';
import signInFormConstantsAR from '../views/auth/i18n/SigninForm.i18n.ar';
import activationDialogConstantsEn from '../views/userManagement/i18n/dialogs/activationDialog.i18n.en';
import activationDialogConstantsAr from '../views/userManagement/i18n/dialogs/activationDialog.i18n.ar';
import inventoryManagementConstantsEn from '../views/inventoryManagement/i18n/inventoryList/inventoryManagement.i18n.en';
import inventoryManagementConstantsAr from '../views/inventoryManagement/i18n/inventoryList/inventoryManagement.i18n.ar';
import tableConstantsAR from '../views/usersApproval/components/i18n/table.ar';
import tableConstantsEN from '../views/usersApproval/components/i18n/table.en';
import usersApprovalConstantsAR from '../views/usersApproval/i18n/usersApproval.ar';
import usersApprovalConstantsEN from '../views/usersApproval/i18n/usersApproval.en';
import previewEditorDialogConstantEN from '../i18n/previewEditorDialog.i18n.en';
import previewEditorDialogConstantAR from '../i18n/previewEditorDialog.i18n.ar';
import editVideoDataConstantsEn from '../views/inventoryManagement/i18n/editVideoData/editVideoData.i18n.en';
import editVideoDataConstantsAr from '../views/inventoryManagement/i18n/editVideoData/editVideoData.i18n.ar';
import manageAdminProfileConstantsEn from '../views/userManagement/i18n/manageAdminProfile/manageAdminProfile.i18n.en';
import manageAdminProfileConstantsAr from '../views/userManagement/i18n/manageAdminProfile/manageAdminProfile.i18n.ar';
import topBarDropDownConstantsEn from '../i18n/topBarDropDown.i18n.en';
import topBarDropDownConstantsAr from '../i18n/topBarDropDown.i18n.ar';
import featuredContentConstantsEn from '../views/featuredContent/i18n/featuredContent.i18n.en';
import featuredContentConstantsAr from '../views/featuredContent/i18n/featuredContent.i18n.ar';
import snackbarConstantsEn from '../i18n/snackbar.i18n.en';
import snackbarConstantsAr from '../i18n/snackbar.i18n.ar';
import newsConstantsEn from '../views/cms/i18n/news/news.i18n.en';
import newsConstantsAr from '../views/cms/i18n/news/news.i18n.ar';
import newLetterConstantsEn from '../views/cms/i18n/new/new.i18n.en';
import newLetterConstantsAr from '../views/cms/i18n/new/new.i18n.ar';
import permissionsConstantEn from '../views/userManagement/i18n/permissions/permissions.i18n.en';
import permissionsConstantAr from '../views/userManagement/i18n/permissions/permissions.i18n.ar';
import actionPanelButtonsConstantsAR from '../i18n/actionPanelButtons.i18n.ar';
import actionPanelButtonsConstantsEN from '../i18n/actionPanelButtons.i18n.en';
import statusDialogConstatnsAr from '../views/cms/i18n/blog/StatusDialog.i18n.ar';
import statusDialogConstatnsEn from '../views/cms/i18n/blog/StatusDialog.i18n.en';
import homePageConstantsAr from '../views/HomePage/i18n/homePage.i18n.ar';
import homePageConstantsEn from '../views/HomePage/i18n/homePage.i18n.en';
import proposalRequestsConstantsAR from '../views/proposalRequests/i18n/proposalRequests.i18n.ar';
import proposalRequestsConstantsEN from '../views/proposalRequests/i18n/proposalRequests.i18n.en';
import proposalDialogConstantsAR from '../views/proposalRequests/i18n/proposalDialog.i18n.ar';
import proposalDialogConstantsEN from '../views/proposalRequests/i18n/proposalDialog.i18n.en';
import tableDataStateConstantsAr from '../i18n/tableDataState.i18n.ar';
import tableDataStateConstantsEn from '../i18n/tableDataState.i18n.en';
import chatTranslationsAR from '../views/messages/i18n/chat.i18n.ar';
import chatTranslationsEN from '../views/messages/i18n/chat.i18n.en';
import systemSettingsTranslationsAR from '../views/settings/i18n/systemSettings.i18n.ar';
import systemSettingsTranslationsEN from '../views/settings/i18n/systemSettings.i18n.en';
import statusFilterConstantsAr from '../i18n/statusFilter.i18n.ar';
import statusFilterConstantsEn from '../i18n/statusFilter.i18n.en';
import OrdersManagementConstantsAr from '../views/ordersManagement/i18n/ordersManagment.i18n.ar';
import OrdersManagementConstantsEn from '../views/ordersManagement/i18n/ordersManagment.i18n.en';
import editCheckoutTermsConditionsConstantsAr from '../views/cms/i18n/editCheckoutTermsConditions/editCheckoutTermsConditions.i18n.ar';
import editCheckoutTermsConditionsConstantsEn from '../views/cms/i18n/editCheckoutTermsConditions/editCheckoutTermsConditions.i18n.en';
import invoicesConstantsAR from '../views/invoices/i18n/invoices.ar';
import invoicesConstantsEN from '../views/invoices/i18n/invoices.en';
import editInvoiceDialogConstantsAR from '../views/invoices/i18n/EditInvoiceDialog.ar';
import editInvoiceDialogConstantsEN from '../views/invoices/i18n/EditInvoiceDialog.en';
import invoiceDetailsConstantsAR from '../views/invoices/i18n/invoiceDetails.i18n.ar';
import invoiceDetailsConstantsEN from '../views/invoices/i18n/invoiceDetails.i18n.en';
import notificationAR from '../i18n/notification.i18n.ar';
import notificationEN from '../i18n/notification.i18n.en';
import notificationsListTranslationsAR from '../views/notifications/i18n/notifications.i18n.ar';
import notificationsListTranslationsEN from '../views/notifications/i18n/notifications.i18n.en';
import DashboardConstantsEN from '../views/dashboard/i18n/dashboard.i18n.en';
import DashboardConstantsAR from '../views/dashboard/i18n/dashboard.i18n.ar';
import ReportsConstantsAR from '../views/reports/i18n/reports.i18n.ar';
import ReportsConstantsEN from '../views/reports/i18n/reports.i18n.en';
import DownloadButtonConstAR from '../i18n/downloadButton.i18n.ar';
import DownloadButtonConstEN from '../i18n/downloadButton.i18n.en';
import NotFoundConstantsAR from '../i18n/notFound.i18n.ar';
import NotFoundConstantsEN from '../i18n/notFound.i18n.en';
import DeletedMediaConstantsEn from '../views/inventoryManagement/i18n/deletedMedia/deletedMedia.i18n.en';
import DeletedMediaConstantsAr from '../views/inventoryManagement/i18n/deletedMedia/deletedMedia.i18n.ar';

export const translations = {
  translationEN: {
    ...copyRightsConstantEN,
    ...validationsEN,
    ...copyRightsConstantEN,
    ...adminUserConstantsEn,
    ...adminUserSharedConstantsEn,
    ...topBarConstantsEN,
    ...sideBarConstantsEN,
    ...cmsSharedConstantsEn,
    ...cmsEditPrivacyPolicyConstantsEn,
    ...editTermsConditionsConstantsEn,
    ...editCookiesPoliciesConstantsEn,
    ...editFAQsConstantsEn,
    ...editAboutUsEn,
    ...blogConstantsEn,
    ...blogListConstantsEn,
    ...successStoriesConstantsEn,
    ...twoFactorFormConstantsEN,
    ...approvedDomainsConstantsEn,
    ...adminUsersListConstantsEn,
    ...searchPlaceHolderConstantsEn,
    ...tableConstantsEn,
    ...cmsPagesConstantsEn,
    ...userManagementConstantsEn,
    ...forgotPasswordFormConstantsEN,
    ...resetPasswordFormConstantsEN,
    ...signInFormConstantsEN,
    ...activationDialogConstantsEn,
    ...editVideoDataConstantsEn,
    ...previewEditorDialogConstantEN,
    ...inventoryManagementConstantsEn,
    ...tableConstantsEN,
    ...usersApprovalConstantsEN,
    ...previewEditorDialogConstantEN,
    ...manageAdminProfileConstantsEn,
    ...topBarDropDownConstantsEn,
    ...featuredContentConstantsEn,
    ...snackbarConstantsEn,
    ...newsConstantsEn,
    ...newLetterConstantsEn,
    ...permissionsConstantEn,
    ...actionPanelButtonsConstantsEN,
    ...statusDialogConstatnsEn,
    ...homePageConstantsEn,
    ...tableDataStateConstantsEn,
    ...proposalRequestsConstantsEN,
    ...proposalDialogConstantsEN,
    ...chatTranslationsEN,
    ...systemSettingsTranslationsEN,
    ...statusFilterConstantsEn,
    ...OrdersManagementConstantsEn,
    ...editCheckoutTermsConditionsConstantsEn,
    ...invoicesConstantsEN,
    ...editInvoiceDialogConstantsEN,
    ...invoiceDetailsConstantsEN,
    ...notificationEN,
    ...notificationsListTranslationsEN,
    ...DashboardConstantsEN,
    ...ReportsConstantsEN,
    ...DownloadButtonConstEN,
    ...NotFoundConstantsEN,
    ...DeletedMediaConstantsEn,
  },
  translationAR: {
    ...copyRightsConstantAR,
    ...validationsAR,
    ...copyRightsConstantAR,
    ...adminUserConstantsAr,
    ...adminUserSharedConstantsAr,
    ...topBarConstantsAR,
    ...sideBarConstantsAR,
    ...cmsSharedConstantsAr,
    ...cmsEditPrivacyPolicyConstantsAr,
    ...editTermsConditionsConstantsAr,
    ...editCookiesPoliciesConstantsAr,
    ...editFAQsConstantsAr,
    ...editAboutUsAr,
    ...blogConstantsAr,
    ...blogListConstantsAr,
    ...successStoriesConstantsAr,
    ...twoFactorFormConstantsAR,
    ...approvedDomainsConstantsAr,
    ...adminUsersListConstantsAr,
    ...searchPlaceHolderConstantsAr,
    ...tableConstantsAr,
    ...cmsPagesConstantsAr,
    ...userManagementConstantsAr,
    ...forgotPasswordFormConstantsAR,
    ...resetPasswordFormConstantsAR,
    ...signInFormConstantsAR,
    ...activationDialogConstantsAr,
    ...editVideoDataConstantsAr,
    ...previewEditorDialogConstantAR,
    ...inventoryManagementConstantsAr,
    ...tableConstantsAR,
    ...usersApprovalConstantsAR,
    ...previewEditorDialogConstantAR,
    ...manageAdminProfileConstantsAr,
    ...topBarDropDownConstantsAr,
    ...featuredContentConstantsAr,
    ...snackbarConstantsAr,
    ...newsConstantsAr,
    ...newLetterConstantsAr,
    ...permissionsConstantAr,
    ...actionPanelButtonsConstantsAR,
    ...statusDialogConstatnsAr,
    ...homePageConstantsAr,
    ...tableDataStateConstantsAr,
    ...proposalRequestsConstantsAR,
    ...proposalDialogConstantsAR,
    ...chatTranslationsAR,
    ...systemSettingsTranslationsAR,
    ...statusFilterConstantsAr,
    ...OrdersManagementConstantsAr,
    ...editCheckoutTermsConditionsConstantsAr,
    ...invoicesConstantsAR,
    ...editInvoiceDialogConstantsAR,
    ...invoiceDetailsConstantsAR,
    ...notificationAR,
    ...notificationsListTranslationsAR,
    ...DashboardConstantsAR,
    ...ReportsConstantsAR,
    ...DownloadButtonConstAR,
    ...NotFoundConstantsAR,
    ...DeletedMediaConstantsAr,
  },
};
